/** Public FAQ for the 529 migration, linked from the confirmed dialog. */
export const CAPITAL_GROUP_MIGRATION_FAQ_URL = "https://www.futuremoney.co/529-migration-faq";
